export default {
    hy: {
      title: 'Hanclouds 瀚云工业互联网平台演示',
      meta: {
        keywords: '瀚云，朗新，工业互联网，演示项目',
        description: 'Hanclouds 瀚云工业互联网平台演示'
      },
      power: '电源开关',
      fan: '扇叶开关',
      alarm: '报警测试',
      share: '分享链接',
      scan: '请扫描下方二维码链接设备',
      copy: '复制以下内容发给您的好友(该链接只能使用一次)',
      copyLink: '复制链接',
      spiral: '螺旋',
      gryo: '机身',
      deviceOn: '设备小部件开关打开',
      deviceOff: '设备小部件开关关闭',
      equipmentOn: '设备motor电源打开',
      equipmentOff: '设备motor电源关闭',
      productsMaximum: '用户产品数达最大值，无法创建演示产品',
      linkCopied: '分享链接已复制',
      notSupport: '该浏览器不支持分享',
      shareUsed: '当前分享连接已经使用',
      connectionBroken: '连接断开，若要继续使用， 请刷新',
      offline: '设备已下线',
      online: '设备已上线',
      networkNot: '当前网络环境不好',
      noPushInfo: '暂无推送信息',
      dataF: '订阅数据失败，正在尝试重新订阅',
      lost: '失去连接,正在尝试重新订阅',
      reconnect: '当前环境网络差，正在尝试重连'
    },
  acc: {
    point: '加速器数据点',
    time: '时间',
    speed: '速度'
  },
  gyroscope: {
      point: '陀螺仪数据点',
      time: '时间',
  },
  miss: {
    notExist: '抱歉！你访问的页面不存在',
    disconnected: '设备已经断开链接！'
  },
  mobile: {
    share: '分享',
    linkSucceeded: '设备链接成功',
    linkFailed: '设备链接失败',
    power: '电源开关',
    fan: '扇叶开关',
    tips: '操作提示',
    powerSwitch: '打开电源开关，接收数据，反之不再推送数据',
    rotate: '上下左右旋转模拟陀螺仪数据',
    transverse: '设备横向加速移动模拟加速器',
    click: '点击报警按钮测试命令下行',
    open: '打开多屏幕，数据可同步展示',
    qr: '二维码已经使用',
    devicemotion: '本设备不支持devicemotion事件',
    deviceorientatio: '本设备不支持deviceorientatio事件',
    rescan: '当前环境网络差，请重新扫码二维码'
  },
  notFound: '抱歉！你访问的页面不存在',
  log: '操作日志',
  tips: {
    title: '操作提示',
    m1: '1、打开电源开关，接收数据，',
    m2: '反之不再推送数据；',
    m3: '2、上下左右旋转模拟陀螺仪数据；',
    m4: '3、设备横向加速移动模拟加速器；',
    m5: '4、点击报警按钮测试命令下行；',
    m6: '5、打开多屏幕，数据可同步展示；'
  },
  part: {
      m1: '设备名称',
      m2: '设备型号',
      m3: '设备材质'
  },
  modelMixin: '模型加载失败，请刷新重试',
  close: '关闭'
};



// WEBPACK FOOTER //
// ./src/i18n/langs/platform/platform.zh-CN.js